import React from "react";
import { Callout, RichText } from "@bared/ui";

export const SearchListEmpty = () => {
  const title = `Sorry, no products were found.`;
  const subtitle = `Try clearing some of your filters.`;

  return (
    <Callout className="w-[fit-content]" variant="secondary" size="large">
      <RichText>
        <p>
          <strong>{title}</strong> {subtitle}
        </p>
      </RichText>
    </Callout>
  );
};
